import cagPdfPrinter from '@/services/utils/pdf/cagPdfPrinter';
import handleHospital from '@/services/modules/hospital';
import handleCompany from "@/services/modules/company";

const cagPdfHelper = () => {
    const { exportToPDF } = cagPdfPrinter();
    const { fetchSingleNote, fetchAdmissionNoteList } = handleHospital();
    const { fetchCompanyInfo } = handleCompany();

    const generatePdf = (ipdId, companyId) => {
        let companyQuery = `?company_id=${companyId}`;
        let admissionQuery = companyQuery + '&search_type=all&type=cag';
        let ipdData = {};
        let companyInfo = {};
        let noteTypes = [];

        return Promise.all([
            fetchAdmissionNoteList(admissionQuery).then((res) => {
                if(res.status) noteTypes.push(...res.data)
            }),
            fetchSingleNote(companyQuery, ipdId).then( (res) => {
                if(!res.status) return 
                ipdData = res.data;
            }),
            fetchCompanyInfo(companyId).then( (res) => {
                if(res.status) companyInfo = res.data;
            })
        ]).then(() => {
            setNoteData(ipdData.notes, noteTypes);
            exportToPDF(companyInfo, ipdData, noteTypes);
        }).catch((e) => {
            console.log(e);
        })
    }

    const setNoteData = (notes, noteTypes) => {
        noteTypes.forEach(group => {
            group.notes.forEach(note => {
                const matchedNote = notes.find(n => n.type === note.value);
                note.note_names = matchedNote.note ?? [];
            });
        });
    };

    return {
        generatePdf
    }
}

export default cagPdfHelper;